/**
 * Identify whether the current view is for a consultant's client (a prospect taking
 * an assessment) rather than the BizPulse AI marketing audience.
 *
 * Returns true when:
 *  - A tenant brand is active (subdomain or ?tenant=…), OR
 *  - The route is an assessment / results / report / sample / join path.
 */
export function isClientView(pathname, tenant) {
  if (tenant) return true;
  if (!pathname) return false;
  return (
    pathname.startsWith("/c") ||
    pathname.startsWith("/assess") ||
    pathname.startsWith("/results") ||
    pathname.startsWith("/report") ||
    pathname.startsWith("/sample") ||
    pathname.startsWith("/join")
  );
}
